export const columns = [
  {
    label: "Policy #",
    field: "policy_number",
    sort: "asc",
  },
  {
    label: "Insurance Company",
    field: "insurance_company",
    sort: "asc",
  },
  {
    label: "Insured",
    field: "insured",
    sort: "asc",
  },
  {
    label: "Class Of Business",
    field: "cob",
    sort: "asc",
  },
  {
    label: "Sum Insured",
    field: "sum_insured",
    sort: "asc",
  },
  {
    label: "Rate",
    field: "rate",
    sort: "asc",
  },
  {
    label: "Status",
    field: "offer_status",
    sort: "asc",
  },
  {
    label: "Offer Date",
    field: "offer_date",
    sort: "asc",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "asc",
  },
];
